import React, { useContext, useEffect, useMemo, useState, useRef } from 'react';
import { useTheme } from '@mui/material/styles';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Autocomplete,
    Button,
    Container,
    Grid,
    IconButton,
    MenuItem,
    Stack,
    styled,
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TableCell,
    TablePagination,
    TableRow,
    tableCellClasses,
    Paper,
    TextField,
    Typography,
    Chip,
    Tooltip, Checkbox, InputAdornment, Modal, Box
} from '@mui/material';
import {
    InsertDriveFile as FileIcon,
    PictureAsPdf as PdfIcon,
    Description as DocIcon,
    Image as ImageIcon,
    Close as CloseIcon,
    FilterAlt as FilterAltIcon,
    ExpandMore as ExpandMoreIcon
} from '@mui/icons-material';
import moment from 'moment';
import { saveAs } from 'file-saver';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import axios from '../../utils/axios';
import UIContext from '../../context/UIContext';
import NoResultsFound from '../../components/NoResultsFound';
// Then at the top of your component:

const StyledTableCell = styled(TableCell)({
    color: 'white',
    fontWeight: '600',
    minWidth: '150px',
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#4379F2',
    },
    whiteSpace: 'nowrap',
});

const statusOptions = [
    { label: 'All', value: '0' },
    { label: 'Completed', value: 'Completed' },
    { label: 'Failed', value: 'Failed' },
];


const searchByOptions = [
    { label: 'Phone Number', value: 'phonenumber' },
    { label: 'Ledger', value: 'ledger' },
];

const shipmentTypeOptionsUK = [
    { label: 'All', value: 0 },
    { label: 'Air Cargo', value: 'courier' },
    { label: 'Sea Cargo', value: 'cargo' },
];

const shipmentTypeOptionsIN = [
    { label: 'Air Cargo', value: 'courier' },
];

function ComplaintMailLog() {

    const theme = useTheme();
    const shipmentTypeRef = useRef(null);
    const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);
    const [expanded, setExpanded] = useState(true);
    const [branchList, setBranchList] = useState([]);
    const [ledgerPhoneFilterData, setLedgerPhoneFilterData] = useState([]);
    const [getDataForView, setGetDataForView] = useState([]);
    const [allUserData, setAllUserData] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [isActive, setIsActive] = useState(false);
    const [orderNoCollection, setOrderNoCollection] = useState([]);
    const [filterInputs, setFilterInputs] = useState({
        fromDate: moment().startOf('month').format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        status: '0',
        ledger: '',
        sentBy: '',
        searchBy: 'phonenumber',
        shipmentType: sessionStorage.getItem('country') === 'UK' ? 0 : 'courier',
        selectedBookOrder: null,
    });
    const [countryList, setCountryList] = useState([]);
    const [dateFilterEnabled, setDateFilterEnabled] = useState(false);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [currentAttachment, setCurrentAttachment] = useState(null);

    const [formErrors, setFormErrors] = useState({
        fromDate: '',
        toDate: '',
    });
    const handleDateFilterToggle = (event) => {
        setDateFilterEnabled(event.target.checked);
    };

    const getAllData = async () => {
        if (!validateFilters()) {
            return; // If validation fails, stop the request
        }
        try {
            showLoading();
            const config = {
                headers: {
                    Country: sessionStorage.getItem('country'),
                },
            };
            const response = await axios.post(`Complaint/ComplaintCommon/GetAllComplaintMailLog`, {
                ledgerId: filterInputs.ledger?.CUSTOMERID || 0,
                shipmentType: filterInputs.shipmentType || 0,
                BookOrderId: filterInputs.selectedBookOrder?.OrderId || 0,
                fromDate: moment(filterInputs.fromDate).format('YYYYMMDD'),
                toDate: moment(filterInputs.toDate).format('YYYYMMDD'),
                status: filterInputs.status,
                sentBy: filterInputs.sentBy.User_Id || 0,
            }, config)
            setGetDataForView(response.data);
        }
        catch (e) {
            openSnackBar('Something went wrong! Try again.', 'error');
            setGetDataForView([]);
        }
        hideLoading();
    }

    const GetOrderFollowupTrackerExcel = async () => {
        if (!validateFilters()) {
            return; // If validation fails, stop the request
        }
        try {
            showLoading();
            const config = {
                headers: {
                    Country: sessionStorage.getItem('country'),
                },
            };
            const response = await axios.post(`Complaint/ComplaintCommon/ComplaintMailLogExcelExport`, {
                ledgerId: filterInputs.ledger?.CUSTOMERID || 0,
                shipmentType: filterInputs.shipmentType || 0,
                BookOrderId: filterInputs.selectedBookOrder?.OrderId || 0,
                fromDate: moment(filterInputs.fromDate).format('YYYYMMDD'),
                toDate: moment(filterInputs.toDate).format('YYYYMMDD'),
                status: filterInputs.status,
                sentBy: filterInputs.sentBy.User_Id || 0,
                OrderNo: filterInputs.selectedBookOrder?.OrderNo || '',
                searchby: filterInputs.searchBy,
                ledger: filterInputs.ledger?.CUSTOMERNAME || '',
                phonenumber: filterInputs.ledger?.Phone || '',
                sentByName: filterInputs.sentBy.User_Name || '',
            }, { responseType: 'blob', ...config })

            const excelBlob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
            });
            saveAs(excelBlob, `Complaint Mail Log-${moment(new Date()).format('MMMM Do YYYY, h-mm a')}`);
            setTimeout(() => {
                hideLoading();
            }, 2000);
        }
        catch (error) {
            if (error.response?.status === 404) {
                openSnackBar('No records found to export.', 'error');
            } else {
                openSnackBar('Something went wrong! Try again.', 'error');
            }
        }
        hideLoading();
    }

    const validateFilters = () => {
        const errors = {};
        // Validate fromDate: should not be empty
        if (!filterInputs.fromDate) {
            errors.fromDate = 'From date is required';
        } else if (!moment(filterInputs.fromDate, 'YYYY-MM-DD', true).isValid()) {
            errors.fromDate = 'Invalid date format';
        }

        // Validate toDate: should not be empty and be a valid date
        if (!filterInputs.toDate) {
            errors.toDate = 'To date is required';
        } else if (!moment(filterInputs.toDate, 'YYYY-MM-DD', true).isValid()) {
            errors.toDate = 'Invalid date format';
        }

        setFormErrors(errors);
        return Object.keys(errors).length === 0; // Return true if no errors
    };

    const handleFilterInputs = (e) => {
        setFilterInputs({
            ...filterInputs,
            [e.target.name]: e.target.value,
        });
    };

    const GetAllHelpUserData = async () => {
        try {
            showLoading();
            const config = {
                headers: {
                    Country: sessionStorage.getItem('country'),
                },
            };
            const response = await axios.get('Complaint/ComplaintCommon/GetAllComplaintUser', config);
            setAllUserData(response.data);
        } catch (e) {
            openSnackBar('Something Went Wrong', 'error');
        }
        hideLoading();
    };


    async function GetAllOrderNo(shiptype, value) {
        showLoading();
        try {
            const config = {
                headers: {
                    Country: sessionStorage.getItem('country'),
                },
            };
            const CustomerId = value.CUSTOMERID || filterInputs.ledger?.CUSTOMERID || 0;
            if (shiptype === 'courier' || shiptype === 'cargo') {
                const response = await axios.post('Complaint/ComplaintCommon/GetAllCourierCargoComplaintBookingNo', {
                    shipmentType: shiptype,
                    customerId: CustomerId,
                    routeType: 'ComplaintLog'
                }, config);
                setOrderNoCollection(response.data);
            } else {
                setOrderNoCollection([]);
            }
        } catch (e) {
            openSnackBar('Something Went Wrong try Again !', 'error');
        }
        hideLoading();
    }

    const GetAllHelpData = async () => {
        try {
            showLoading();
            const userID = sessionStorage.getItem('UserId');
            const userRole = sessionStorage.getItem('userRole');
            const companyId = 4;

            const config = {
                headers: {
                    Country: sessionStorage.getItem('country'),
                },
            };

            let customerHelpUrl = '';

            if (userRole === 'Admin') {
                customerHelpUrl = '/master/customer/GetCustomerHelp/4';
            } else {
                customerHelpUrl = `/Transactions/SalesControls/GetCustomerHelpForSE/${companyId}/${userID}/0`;
            }

            const [ledgerResponse] = await Promise.all([
                axios.get(customerHelpUrl, config),
            ]);
            setLedgerPhoneFilterData(ledgerResponse.data);
        } catch (e) {
            openSnackBar('Something Went Wrong', 'error');
        }
        hideLoading();
    };

    useEffect(() => {
        getAllData();
        GetAllHelpData();
        GetAllHelpUserData();
    }, []);

    // pagination
    const { totalRows, currentPage } = useMemo(() => {
        const totalRows = getDataForView.length;
        const totalPages = Math.ceil(totalRows / rowsPerPage);
        const currentPage = Math.max(0, Math.min(page, totalPages - 1));
        const emptyRows = rowsPerPage - Math.min(rowsPerPage, totalRows - page * rowsPerPage);

        return { totalRows, currentPage };
    }, [getDataForView, page, rowsPerPage]);


    return (
        <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
            <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
                <Typography
                    variant="h5"
                    p={1}
                    boxShadow={1}
                    borderColor="#11235A"
                    textAlign={'center'}
                    borderRadius={2}
                    pl={2}
                    color="white"
                    sx={{
                        // borderRadius: 50,
                        background: '#8EACCD',
                        boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
                    }}
                >
                    <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
                        Complaint Mail Log
                    </Typography>
                </Typography>
            </Grid>
            <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4, my: 2 }}>
                <Accordion
                    expanded={expanded}
                    onChange={() => {
                        setExpanded((expand) => !expand);
                    }}
                    disableGutters
                    sx={{ borderTop: 'none', borderColor: 'black', backgroundColor: 'inherit' }}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon style={{ color: '#8EACCD' }} />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        sx={{ borderTop: 'none' }}
                    >
                        <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
                            <IconButton aria-label="ExpandMoreIcon" color="#8EACCD">
                                <FilterAltIcon style={{ color: '#8EACCD', width: 24, height: 24 }} />
                            </IconButton>
                            <Typography
                                sx={{
                                    color: '#8EACCD',
                                    '&.active': {
                                        color: 'text.primary',
                                        bgcolor: 'action.selected',
                                        fontWeight: 'fontWeightBold',
                                    },
                                }}
                                variant="h6"
                            >
                                Filters
                            </Typography>
                        </Stack>
                    </AccordionSummary>

                    <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 3 }}>
                        <Grid container spacing={2} p={1} pt={0} mb={0.5} rowSpacing={2} columnSpacing={1}>
                            <Grid item md={2} xs={12}>
                                {/* Search by Filter */}
                                <TextField
                                    fullWidth
                                    select
                                    label="Search by"
                                    name="searchBy"
                                    value={filterInputs.searchBy}
                                    onChange={(e) => {
                                        setFilterInputs({
                                            ...filterInputs,
                                            ledger: '',
                                            searchBy: e.target.value,
                                        });
                                    }}
                                    variant="outlined"
                                    size="small"
                                >
                                    {searchByOptions.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item md={4} xs={12}>
                                <Autocomplete
                                    key={filterInputs.searchBy}
                                    options={ledgerPhoneFilterData}
                                    getOptionLabel={(customer) =>
                                        filterInputs.searchBy === 'phonenumber' ? customer.Phone : customer.CUSTOMERNAME
                                    }
                                    renderOption={(props, customer) => (
                                        <li {...props} key={customer.CUSTOMERID}>
                                            {filterInputs.searchBy === 'phonenumber' ? customer.Phone : customer.CUSTOMERNAME}
                                        </li>
                                    )}
                                    isOptionEqualToValue={(customer) => customer.CUSTOMERID === filterInputs.ledger.CUSTOMERID}
                                    value={filterInputs.ledger || null}
                                    name="ledger"
                                    onChange={(event, value) => {
                                        setFilterInputs({
                                            ...filterInputs,
                                            ledger: value,
                                        });
                                        GetAllOrderNo(filterInputs.shipmentType, value)
                                    }}
                                    size="small"
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={filterInputs.searchBy === 'phonenumber' ? 'Phone Number' : 'Ledger'}
                                        />
                                    )}
                                />
                            </Grid>
                            {/* Shipment Type */}
                            <Grid item md={2} xs={12}>
                                <TextField
                                    fullWidth
                                    select
                                    label="Shipment Type"
                                    name="shipmenttype"
                                    value={filterInputs.shipmentType}
                                    onChange={(e) => {
                                        const value = Number(e.target.value);
                                        setFilterInputs(prevState => ({
                                            ...prevState,
                                            shipmentType: e.target.value,
                                            selectedBookOrder: Number(e.target.value) === 0 ? null : prevState.selectedBookOrder,
                                        }));
                                        GetAllOrderNo(e.target.value, 0);
                                    }}
                                    variant="outlined"
                                    size="small"
                                    inputRef={shipmentTypeRef}
                                >
                                    {sessionStorage.getItem('country') === 'UK' ?
                                        shipmentTypeOptionsUK.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        )) :
                                        shipmentTypeOptionsIN.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))
                                    }
                                </TextField>
                            </Grid>
                            {/* Booking No */}
                            <Grid item md={2} xs={12}>
                                <Autocomplete
                                    key={filterInputs.searchBy}
                                    options={orderNoCollection}
                                    getOptionLabel={(option) => option.OrderNo}
                                    renderOption={(props, option) => (
                                        <li {...props} key={option.OrderId}>
                                            {option.OrderNo}
                                        </li>
                                    )}
                                    isOptionEqualToValue={(option, value) => option.OrderId === value?.OrderId}
                                    value={filterInputs.selectedBookOrder}
                                    onChange={(event, value) => {
                                        setFilterInputs({
                                            ...filterInputs,
                                            selectedBookOrder: value,
                                        });
                                    }}
                                    size="small"
                                    renderInput={(params) => <TextField {...params} label="Booking No" />}
                                />
                            </Grid>
                            <Grid item md={2} xs={12}>
                                {/* From Date */}
                                <TextField
                                    fullWidth
                                    label="From Date"
                                    type="date"
                                    name="fromDate"
                                    value={filterInputs.fromDate}
                                    onChange={handleFilterInputs}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    size="small"
                                    error={!!formErrors.fromDate}
                                    helperText={formErrors.fromDate}
                                    inputProps={{ max: '9999-12-31' }}
                                />
                            </Grid>
                            <Grid item md={2} xs={12}>
                                {/* To Date */}
                                <TextField
                                    fullWidth
                                    label="To Date"
                                    type="date"
                                    name="toDate"
                                    value={filterInputs.toDate}
                                    onChange={handleFilterInputs}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    size="small"
                                    error={!!formErrors.toDate}
                                    helperText={formErrors.toDate}
                                    inputProps={{ max: '9999-12-31' }}
                                />
                            </Grid>
                            {/* Status */}
                            <Grid item md={2} xs={12}>
                                <TextField
                                    fullWidth
                                    select
                                    label="Status"
                                    name="status"
                                    value={filterInputs.status}
                                    onChange={handleFilterInputs}
                                    variant="outlined"
                                    size="small"
                                >
                                    {statusOptions.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item md={3} xs={12}>
                                <Autocomplete
                                    options={allUserData}
                                    getOptionLabel={(user) => user.User_Name}
                                    renderOption={(props, user) => (
                                        <li {...props} key={user.User_Id}>
                                            {user.User_Name}
                                        </li>
                                    )}
                                    isOptionEqualToValue={(user) =>
                                        user.User_Id === filterInputs.sentBy.User_Id
                                    }
                                    value={filterInputs.sentBy || null}
                                    name="sentBy"
                                    onChange={(event, value) => {
                                        setFilterInputs({ ...filterInputs, sentBy: value });
                                    }}
                                    size="small"
                                    renderInput={(params) => <TextField {...params} label="Sent By" />}
                                />
                            </Grid>

                            {/* <Grid container justifyContent="flex-end"> */}
                            <Grid item xs={1} sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                                {/* View Button */}
                                <Button variant="contained" color="primary" onClick={getAllData} fullWidth sx={{ boxShadow: 0 }}>
                                    View
                                </Button>
                            </Grid>


                            <Grid item xs={1} sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                                <Button
                                    variant="contained"
                                    style={{ color: 'white', backgroundColor: '#118a27' }}
                                    onClick={GetOrderFollowupTrackerExcel}
                                    fullWidth
                                >
                                    Excel
                                </Button>
                            </Grid>
                            {/* </Grid> */}
                        </Grid>
                        {getDataForView.length > 0 ? (
                            <>
                                <TableContainer component={Paper} elevation={2} sx={{ bgcolor: 'inherit', maxHeight: 600 }}>
                                    <Table size="small" stickyHeader>
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell align="center">S.No</StyledTableCell>
                                                <StyledTableCell align="center">Customer Name</StyledTableCell>
                                                <StyledTableCell align="center">Booking No</StyledTableCell>
                                                <StyledTableCell align="center">Shipment Type</StyledTableCell>
                                                <StyledTableCell align="center">From</StyledTableCell>
                                                <StyledTableCell align="center">To</StyledTableCell>
                                                <StyledTableCell align="center">CC</StyledTableCell>
                                                <StyledTableCell align="center">Bcc</StyledTableCell>
                                                <StyledTableCell align="center">Subject</StyledTableCell>
                                                <StyledTableCell align="center">Body</StyledTableCell>
                                                <StyledTableCell align="center">Attachment</StyledTableCell>
                                                <StyledTableCell align="center">Date/Time</StyledTableCell>
                                                <StyledTableCell align="center">Sent By</StyledTableCell>
                                                <StyledTableCell align="center">Status</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {(rowsPerPage > 0
                                                ? getDataForView.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                : getDataForView
                                            ).map((data, i) => (
                                                <TableRow key={data.complaint_id} hover>
                                                    <TableCell align="center">{data.SNo}</TableCell>
                                                    <TableCell align="center" style={{ whiteSpace: 'nowrap' }}>{data.CustomerName}</TableCell>
                                                    <TableCell align="center" >{data.BookOrderNo}</TableCell>
                                                    <TableCell align="center">{data.shipmenType}</TableCell>
                                                    <TableCell align="center">{data.FromMail}</TableCell>
                                                    <TableCell align="center">{data.ToMail}</TableCell>
                                                    <TableCell align="center">{data.CC}</TableCell>
                                                    <TableCell align="center">{data.BCC}</TableCell>
                                                    <TableCell align="center"><Tooltip title={data.Subject || ''} placement="top" arrow>
                                                        <div
                                                            style={{
                                                                whiteSpace: 'nowrap',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                maxWidth: '150px', // adjust based on your table width
                                                            }}
                                                        >
                                                            {data.Subject}
                                                        </div>
                                                    </Tooltip></TableCell>
                                                    <TableCell align="center">
                                                        <Tooltip title={data.Body || ''} placement="top" arrow>
                                                            <div
                                                                style={{
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    maxWidth: '150px', // adjust based on your table width
                                                                }}
                                                            >
                                                                {data.Body}
                                                            </div>
                                                        </Tooltip>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {data.Attachment && (
                                                            <>
                                                                {['.jpg', '.jpeg', '.png', '.gif'].some(ext =>
                                                                    data.Attachment.toLowerCase().endsWith(ext)) ? (
                                                                    <Tooltip title="Click to view full image">
                                                                        <IconButton onClick={() => {
                                                                            setCurrentAttachment(data.Attachment);
                                                                            setPreviewOpen(true);
                                                                        }}>
                                                                            <img
                                                                                src={`${axios.defaults.commonImageURL}/ComplaintMailLog/${data.Attachment}`}
                                                                                alt="Attachment"
                                                                                style={{
                                                                                    width: '50px',
                                                                                    height: '50px',
                                                                                    objectFit: 'cover',
                                                                                    borderRadius: '4px',
                                                                                    border: '1px solid #e0e0e0',
                                                                                    cursor: 'pointer'
                                                                                }}
                                                                            />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                ) : (
                                                                    <Tooltip title={`Download ${data.Attachment}`}>
                                                                        <Button
                                                                            variant="outlined"
                                                                            startIcon={(() => {
                                                                                const fileExt = data.Attachment.split('.').pop().toLowerCase();
                                                                                switch (fileExt) {
                                                                                    case 'pdf': return <PdfIcon fontSize="large" color="error" />;
                                                                                    case 'doc':
                                                                                    case 'docx': return <DocIcon fontSize="large" color="primary" />;
                                                                                    case 'xls':
                                                                                    case 'xlsx': return <DocIcon fontSize="large" color="success" />;
                                                                                    default: return <FileIcon fontSize="large" />;
                                                                                }
                                                                            })()}
                                                                            href={`${axios.defaults.commonImageURL}/ComplaintMailLog/${data.Attachment}`}
                                                                            download
                                                                            sx={{
                                                                                textTransform: 'none',
                                                                                borderRadius: '4px',
                                                                                padding: '6px 12px',
                                                                                borderColor: '#e0e0e0',
                                                                                '&:hover': {
                                                                                    borderColor: '#bdbdbd'
                                                                                }
                                                                            }}
                                                                        >
                                                                            View
                                                                        </Button>
                                                                    </Tooltip>
                                                                )}
                                                            </>
                                                        )}
                                                    </TableCell>
                                                    <TableCell align="center" style={{ whiteSpace: 'nowrap' }}>{moment.utc(data.Sentdate).format('LLL')}</TableCell>
                                                    <TableCell align="center">{data.userName}</TableCell>
                                                    <TableCell align="center" style={{ whiteSpace: 'nowrap' }}>{data.Status}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>

                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={totalRows}
                                    rowsPerPage={rowsPerPage}
                                    page={currentPage}
                                    onPageChange={(event, newPage) => setPage(newPage)}
                                    onRowsPerPageChange={(event) => {
                                        setRowsPerPage(parseInt(event.target.value, 10));
                                        setPage(0);
                                    }}
                                    mt={2}
                                />
                            </>

                        ) : (
                            <NoResultsFound />
                        )}

                    </AccordionDetails>
                </Accordion>

                <Modal
                    open={previewOpen}
                    onClose={() => setPreviewOpen(false)}
                    aria-labelledby="image-modal"
                    aria-describedby="image-modal-description"
                >
                    <Box sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 2,
                        outline: 'none'
                    }}>
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            mb: 1
                        }}>
                            <Typography variant="h6">Attachment Preview</Typography>
                            <IconButton onClick={() => setPreviewOpen(false)}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                        {currentAttachment && (
                            <>
                                {['.jpg'].some(ext =>
                                    currentAttachment.toLowerCase().endsWith(ext)) ? (
                                    <img
                                        src={`${axios.defaults.commonImageURL}/ComplaintMailLog/${currentAttachment}`}
                                        alt="Full size attachment"
                                        style={{
                                            maxHeight: '80vh',
                                            maxWidth: '80vw',
                                            display: 'block'
                                        }}
                                    />
                                ) : (
                                    <Typography variant="body1" sx={{ p: 2 }}>
                                        This file type cannot be previewed. Please download to view.
                                    </Typography>
                                )}
                                <Box sx={{ mt: 2, textAlign: 'right' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            saveAs(
                                                `${axios.defaults.commonImageURL}/ComplaintMailLog/${currentAttachment}`,
                                                currentAttachment
                                            );
                                        }}
                                        size="small"
                                    >
                                        Download
                                    </Button>
                                </Box>
                            </>
                        )}
                    </Box>
                </Modal>

            </Stack>
        </Container>
    )
}

export default ComplaintMailLog